import { render } from "./about.vue?vue&type=template&id=2856e198"
import script from "./about.js?vue&type=script&lang=js&external"
export * from "./about.js?vue&type=script&lang=js&external"

import "./about.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__